import React, { useEffect, useRef } from "react";
import { api, setSession } from "../lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { window.location.replace("/login"); return; }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        const r = await api.post("/auth/google/session", null, {
          headers: { "X-Session-ID": sessionId },
          withCredentials: true,
        });
        // Also keep a light localStorage copy so the SPA header shows the user
        setSession(r.data.session_token, r.data.user);
        const isAdmin = r.data?.user?.role === "admin";
        window.location.replace(isAdmin ? "/admin" : "/dashboard");
      } catch (e) {
        window.location.replace("/login?err=google");
      }
    })();
  }, []);
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", fontFamily: "system-ui", color: "#1e1b4b" }}>
      <div>Signing you in…</div>
    </div>
  );
}
